function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A8E1"
    },
    d: "M256,390.764c-140.262,0-243.29-122.112-243.29-122.112c-5.871-6.959-5.871-18.346,0-25.307 c0,0,103.029-122.112,243.29-122.112s243.289,122.112,243.289,122.112c5.871,6.961,5.871,18.348,0,25.307 C499.29,268.653,396.262,390.764,256,390.764z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 255.993,
    cy: 256.004,
    r: 103.744
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333E48"
    },
    cx: 255.993,
    cy: 256.004,
    r: 60.05
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 304.93,
    cy: 212.222,
    r: 22.073
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E252B"
    },
    d: "M505.616,238.008c-1.079-1.279-26.946-31.695-70.603-62.481 C394.538,146.983,330.624,112.958,256,112.958s-138.538,34.025-179.013,62.569c-43.657,30.788-69.523,61.202-70.603,62.482 c-8.511,10.09-8.511,25.894,0,35.983c1.079,1.279,26.946,31.695,70.603,62.481c40.476,28.544,104.389,62.569,179.013,62.569 s138.538-34.025,179.013-62.569c43.657-30.788,69.523-61.202,70.602-62.481C514.128,263.903,514.128,248.099,505.616,238.008z  M492.965,263.313c-0.253,0.299-25.831,30.322-67.865,59.893c-38.44,27.044-98.982,59.282-169.101,59.282 S125.338,350.25,86.898,323.206c-42.034-29.571-67.611-59.593-67.863-59.891c-3.288-3.896-3.287-10.733-0.002-14.628 c0.254-0.299,25.831-30.322,67.865-59.893c38.439-27.044,98.982-59.282,169.101-59.282S386.66,161.75,425.1,188.794 c42.034,29.571,67.611,59.593,67.862,59.89C496.251,252.582,496.251,259.419,492.965,263.313z M255.997,143.974 c-61.771,0-112.025,50.254-112.025,112.026s50.253,112.026,112.025,112.026c61.771,0,112.025-50.254,112.025-112.026 S317.767,143.974,255.997,143.974z M255.997,351.471c-52.642,0-95.47-42.829-95.47-95.471s42.827-95.471,95.47-95.471 s95.47,42.829,95.47,95.471S308.639,351.471,255.997,351.471z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.8617b2fa0e709fe1bcf1715e11c8d7ab.svg";
export { ForwardRef as ReactComponent };